module.exports = __webpack_public_path__ + "img/image (8).083c4f37.webp";